import {useActionContext} from "@context/actionContext/hooks/useActionContext";
import {ConfirmVariant} from "@ui/confirm/types";

export function useConfirm() {
    const {setConfirm: setConfirmGlobal} = useActionContext()
    const setConfirm = ({message = '', callback, title = '', cancelCallback, variant}: {
        message: string,
        title?: string,
        callback: () => void | null,
        cancelCallback?: () => void | null,
        variant?: ConfirmVariant,
    }) => {
        setConfirmGlobal({
            message, callback, cancelCallback, title, variant, open: true
        })
    };

    return {setConfirm}

};
